export default __webpack_public_path__ + "static/images/professional-tools.3d739ccb.png";